import React, { useState, useEffect } from "react";
import "./App.css";

const API_URL = "https://micontenidohot.com";
const FOTO_DEFAULT = `${API_URL}/uploads/default.jpg`;

const convertirFechaMySQL = (f) => {
  if (!f) return null;
  if (f instanceof Date) return isNaN(f.getTime()) ? null : f;
  if (typeof f !== "string") return null;
  const l = f.trim();
  if (!l) return null;
  const r = new Date(l.includes("T") ? l : l.replace(" ", "T"));
  return isNaN(r.getTime()) ? null : r;
};

const estaVigente = (f, a) => {
  const v = convertirFechaMySQL(f);
  return v ? v.getTime() > a.getTime() : false;
};

const calcularDiasDesdeFecha = (f, a) => {
  const v = convertirFechaMySQL(f);
  if (!v) return 0;
  const d = v.getTime() - a.getTime();
  return d <= 0 ? 0 : Math.ceil(d / (1000 * 60 * 60 * 24));
};

const calcularHorasRestantes = (f, a) => {
  const v = convertirFechaMySQL(f);
  if (!v) return 0;
  const d = v.getTime() - a.getTime();
  return d <= 0 ? 0 : Math.ceil(d / (1000 * 60 * 60));
};

const obtenerUrlFoto = (foto) => {
  if (!foto || typeof foto !== "string") return FOTO_DEFAULT;
  const l = foto.trim();
  if (!l) return FOTO_DEFAULT;
  if (l.startsWith("http://") || l.startsWith("https://")) return l;
  return `${API_URL}/${l.replace(/^\/+/, "")}`;
};

// --- ICONOS SVG ---
const IconoUbicacion = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={{ verticalAlign: "-2px", marginRight: "4px" }}
  >
    <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"></path>
    <circle cx="12" cy="10" r="3"></circle>
  </svg>
);

const IconoTelefono = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={{ verticalAlign: "-2px", marginRight: "4px" }}
  >
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
  </svg>
);

const IconoReloj = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={{ verticalAlign: "-2px", marginRight: "5px" }}
  >
    <circle cx="12" cy="12" r="10"></circle>
    <polyline points="12 6 12 12 16 14"></polyline>
  </svg>
);

const IconoEstrella = () => (
  <svg
    width="13"
    height="13"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={{ verticalAlign: "-2px", marginRight: "5px" }}
  >
    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
  </svg>
);

const IconoFuego = () => (
  <svg
    width="13"
    height="13"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={{ verticalAlign: "-2px", marginRight: "5px" }}
  >
    <path d="M8.5 14.5A2.5 2.5 0 0 0 11 12c0-1.38-.5-2-1-3-1.072-2.143-.224-4.054 2-6 .5 2.5 2 4.5 4 6.5 2 2 3 3.5 3 5.5a7 7 0 1 1-14 0c0-1.153.433-2.229 1-3 1 1.5 2.5 2.5 2.5 2.5z"></path>
  </svg>
);

const IconoCohete = () => (
  <svg
    width="13"
    height="13"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={{ verticalAlign: "-2px", marginRight: "5px" }}
  >
    <path d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z"></path>
    <path d="m12 15-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z"></path>
    <path d="M9 12H4s.55-3.03 2-4c1.62-1.08 3-2 3-2"></path>
    <path d="M12 15v5s3.03-.55 4-2c1.08-1.62 2-3 2-3"></path>
  </svg>
);

const IconoCorona = () => (
  <svg
    width="13"
    height="13"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={{ verticalAlign: "-2px", marginRight: "5px" }}
  >
    <path d="m2 4 3 12h14l3-12-6 7-4-7-4 7-6-7zm3 16h14v2H5z"></path>
  </svg>
);

const IconoFlechaIzquierda = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={{ marginRight: "6px" }}
  >
    <line x1="19" y1="12" x2="5" y2="12"></line>
    <polyline points="12 19 5 12 12 5"></polyline>
  </svg>
);

function MiniCarrusel({ imagenes = [], alt, esPendiente }) {
  const [indice, setIndice] = useState(0);
  const fin = imagenes.length > 0 ? imagenes : [FOTO_DEFAULT];

  useEffect(() => {
    if (imagenes.length <= 1) {
      setIndice(0);
      return;
    }
    const t = setInterval(
      () => setIndice((p) => (p + 1) % imagenes.length),
      4000
    );
    return () => clearInterval(t);
  }, [imagenes.length]);

  useEffect(() => {
    if (indice >= imagenes.length) setIndice(0);
  }, [imagenes.length, indice]);

  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        position: "relative",
        overflow: "hidden",
        borderRadius: "12px",
      }}
    >
      {fin.map((img, i) => (
        <img
          key={`${img}-${i}`}
          src={obtenerUrlFoto(img)}
          alt={`${alt || "Perfil"} - ${i + 1}`}
          onError={(e) => {
            if (e.currentTarget.src !== FOTO_DEFAULT)
              e.currentTarget.src = FOTO_DEFAULT;
          }}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            position: "absolute",
            top: 0,
            left: 0,
            opacity: i === indice ? (esPendiente ? 0.4 : 1) : 0,
            filter: esPendiente ? "blur(8px)" : "none",
            transition: "all 0.6s ease-in-out",
            border: "1px solid #334155",
          }}
        />
      ))}
      {esPendiente && (
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: "rgba(0,0,0,0.3)",
            zIndex: 2,
            textAlign: "center",
            padding: "4px",
          }}
        >
          <span
            style={{
              fontSize: "0.65rem",
              color: "#fde047",
              fontWeight: "bold",
              textShadow: "0 1px 2px rgba(0,0,0,0.8)",
            }}
          >
            EN REVISIÓN
          </span>
        </div>
      )}
    </div>
  );
}

function MisAnuncios({ usuario, alVolver }) {
  const [misAnuncios, setMisAnuncios] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [ahora, setAhora] = useState(() => new Date());
  const [modalQR, setModalQR] = useState(false);
  const [anuncioId, setAnuncioId] = useState(null);
  const [qrImagenBase64, setQrImagenBase64] = useState("");
  const [cargandoQr, setCargandoQr] = useState(false);

  const [modalExito, setModalExito] = useState(false);
  const [modalConfirmar, setModalConfirmar] = useState(false);
  const [datosPendientesPago, setDatosPendientesPago] = useState(null);

  useEffect(() => {
    const int = setInterval(() => setAhora(new Date()), 1000);
    return () => clearInterval(int);
  }, []);

  const obtenerMisAnuncios = async () => {
    if (!usuario?.id) {
      setMisAnuncios([]);
      setCargando(false);
      return;
    }
    try {
      setCargando(true);
      const res = await fetch(
        `${API_URL}/obtener_anuncios.php?user_id=${usuario.id}`
      );
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const data = await res.json();
      setMisAnuncios(
        data.success
          ? (data.anuncios || []).filter(
              (ad) => Number(ad.user_id) === Number(usuario.id)
            )
          : []
      );
    } catch (e) {
      console.error(e);
      setMisAnuncios([]);
    } finally {
      setCargando(false);
    }
  };

  useEffect(() => {
    obtenerMisAnuncios();
  }, [usuario]);

  useEffect(() => {
    if (!modalQR || !anuncioId) return;

    const intervalo = setInterval(async () => {
      try {
        const res = await fetch(
          `${API_URL}/verificar_potenciador.php?anuncio_id=${anuncioId}`
        );
        const data = await res.json();

        if (data.success && data.estado === "aprobado") {
          clearInterval(intervalo);
          setModalQR(false);
          setQrImagenBase64("");
          setAnuncioId(null);
          setModalExito(true);
          obtenerMisAnuncios();
        }
      } catch (error) {
        console.error(error);
      }
    }, 3000);

    return () => clearInterval(intervalo);
  }, [modalQR, anuncioId]);

  const cambiarPlan = (id, tipo, precio) => {
    const nombres = {
      top_7dias: "Top 7 días",
      destacado_7dias: "Destacado 7 días",
      super_top_24h: "Super Top 24 Horas",
      mes_30dias: "Plan 30 días",
    };

    setDatosPendientesPago({
      id,
      tipo,
      precio,
      nombrePlan: nombres[tipo] || tipo,
    });
    setModalConfirmar(true);
  };

  const ejecutarCambioPlan = async () => {
    if (!datosPendientesPago) return;
    const { id, tipo, precio } = datosPendientesPago;

    setModalConfirmar(false);

    try {
      const res = await fetch(`${API_URL}/actualizar_plan.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ anuncio_id: id, tipo_plan: tipo }),
      });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const data = await res.json();

      if (data.success) {
        setAnuncioId(id);
        setModalQR(true);
        setQrImagenBase64("");
        setCargandoQr(true);

        const resQr = await fetch(`${API_URL}/generar_qr_pago.php`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            anuncio_id: id,
            monto: precio,
            user_id: usuario.id,
          }),
        });
        const dataQr = await resQr.json();

        if (dataQr.success && dataQr.qr_image) {
          setQrImagenBase64(dataQr.qr_image);
        } else {
          alert(
            dataQr.mensaje || "No se pudo generar el código QR automático."
          );
        }
      } else {
        alert(data.mensaje || "Error al solicitar el potenciador.");
      }
    } catch (err) {
      console.error(err);
      alert("Error de conexión con el servidor.");
    } finally {
      setCargandoQr(false);
      setDatosPendientesPago(null);
    }
  };

  const cerrarModal = () => {
    setModalQR(false);
    setQrImagenBase64("");
    setAnuncioId(null);
    obtenerMisAnuncios();
  };

  if (cargando) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          backgroundColor: "#fff",
          color: "#000",
        }}
      >
        <p style={{ fontSize: "1.1rem", color: "#64748b" }}>
          Cargando tus anuncios publicados...
        </p>
      </div>
    );
  }

  return (
    <div
      style={{
        width: "100%",
        minHeight: "100vh",
        backgroundColor: "#fff",
        margin: 0,
        padding: 0,
        boxSizing: "border-box",
        position: "relative",
        paddingBottom: "90px",
      }}
    >
      <div
        style={{
          maxWidth: "600px",
          margin: "0 auto",
          fontFamily: "system-ui, sans-serif",
          padding: "20px",
        }}
      >
        {/* HEADER CENTRADO */}
        <header
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            marginBottom: "24px",
            borderBottom: "1px solid #e2e8f0",
            paddingBottom: "16px",
            textAlign: "center",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: "0px",
            }}
          >
            <img
              src="/logo.png"
              alt="Logo"
              style={{ width: "100px", height: "100px", objectFit: "contain" }}
            />
            <h2
              style={{
                margin: 0,
                fontSize: "1.5rem",
                fontWeight: "900",
                letterSpacing: "-0.5px",
                lineHeight: "0px",
              }}
            >
              <span style={{ color: "#ff2c55" }}></span>
              <span style={{ color: "#000" }}></span>
            </h2>
          </div>
        </header>

        {misAnuncios.length === 0 ? (
          <div
            style={{
              textAlign: "center",
              padding: "40px 20px",
              background: "#0f172a",
              borderRadius: "16px",
              border: "1px dashed #334155",
              marginTop: "20px",
            }}
          >
            <p style={{ color: "#94a3b8", margin: 0 }}>
              Aún no tienes ningún anuncio publicado en tu cuenta.
            </p>
          </div>
        ) : (
          <div
            style={{ display: "flex", flexDirection: "column", gap: "20px" }}
          >
            {misAnuncios.map((ad) => {
              const diasFaltantes = calcularDiasDesdeFecha(
                ad.fecha_vencimiento_plan,
                ahora
              );
              const listaImagenes = [ad.imagen, ad.imagen2, ad.imagen3].filter(
                Boolean
              );
              const esPendiente =
                String(ad.status || "").toLowerCase() === "pendiente";
              const tienePlanActivo = estaVigente(
                ad.fecha_vencimiento_plan,
                ahora
              );
              const tieneTopActivo = estaVigente(
                ad.fecha_vencimiento_top,
                ahora
              );
              const tieneDestacadoActivo = estaVigente(
                ad.fecha_vencimiento_destacado,
                ahora
              );
              const tieneSuperTopActivo = estaVigente(
                ad.fecha_vencimiento_super_top,
                ahora
              );
              const esVip = estaVigente(ad.fecha_vencimiento_vip, ahora);

              const esPlan30Dias =
                String(ad.plan || "")
                  .trim()
                  .toLowerCase() === "mes";

              // Verificación si el usuario ya cuenta con algún potenciador activo
              const tieneCualquierPotenciadorActivo =
                tieneTopActivo ||
                tieneDestacadoActivo ||
                tieneSuperTopActivo;

              const esVip30Dias = esVip;

              const puedeComprarPotenciadores = tienePlanActivo && !esPendiente;
              const puedeComprarTopYDestacado =
                esPlan30Dias && tienePlanActivo && !esPendiente;

              const deshabilitarTop =
                esPendiente ||
                !puedeComprarPotenciadores ||
                tieneCualquierPotenciadorActivo;
              const deshabilitarDestacado =
                esVip30Dias ||
                esPendiente ||
                !puedeComprarTopYDestacado ||
                tieneCualquierPotenciadorActivo;
              const deshabilitarSuperTop =
                esVip30Dias ||
                esPendiente ||
                !puedeComprarPotenciadores ||
                tieneCualquierPotenciadorActivo;

              const tipoCompra = String(ad.tipo_plan || "")
                .trim()
                .toLowerCase();

              // Determinar qué mensaje mostrar si tiene potenciador activo
              let mensajeEsperaPotenciador = "";
              if (tieneTopActivo) {
                const diasTop = calcularDiasDesdeFecha(
                  ad.fecha_vencimiento_top,
                  ahora
                );
                mensajeEsperaPotenciador = `Debes esperar ${diasTop} día(s) para que expire tu Top actual antes de comprar otro potenciador.`;
              } else if (tieneDestacadoActivo) {
                const diasDestacado = calcularDiasDesdeFecha(
                  ad.fecha_vencimiento_destacado,
                  ahora
                );
                mensajeEsperaPotenciador = `Debes esperar ${diasDestacado} día(s) para que expire tu Destacado actual antes de comprar otro potenciador.`;
              } else if (tieneSuperTopActivo) {
                const horasSuperTop = calcularHorasRestantes(
                  ad.fecha_vencimiento_super_top,
                  ahora
                );
                mensajeEsperaPotenciador = `Debes esperar ${horasSuperTop} hora(s) para que expire tu Super Top 24H antes de comprar otro potenciador.`;
              } else if (esVip) {
                const diasVip = calcularDiasDesdeFecha(
                  ad.fecha_vencimiento_vip,
                  ahora
                );
                mensajeEsperaPotenciador = `Tienes VIP activo con ${diasVip} día(s) restantes.`;
              }

              return (
                <div
                  key={ad.id}
                  style={{
                    background: "#0f172a",
                    borderRadius: "16px",
                    border: esPendiente
                      ? "1px solid #eab308"
                      : "1px solid #1e293b",
                    padding: "16px",
                    display: "flex",
                    flexDirection: "column",
                    gap: "12px",
                    boxShadow: "0 4px 10px rgba(0,0,0,0.3)",
                  }}
                >
                  <div style={{ display: "flex", gap: "16px" }}>
                    <div
                      style={{
                        width: "90px",
                        height: "120px",
                        flexShrink: 0,
                        position: "relative",
                      }}
                    >
                      <MiniCarrusel
                        imagenes={listaImagenes}
                        alt={ad.nic || ad.nombre}
                        esPendiente={esPendiente}
                      />
                    </div>
                    <div
                      style={{
                        flex: 1,
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                      }}
                    >
                      <div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            marginBottom: "4px",
                            gap: "8px",
                          }}
                        >
                          <h3
                            style={{
                              margin: 0,
                              fontSize: "1.15rem",
                              color: "#fff",
                            }}
                          >
                            {ad.nic || ad.nombre || "Sin nombre"},{" "}
                            <span
                              style={{ color: "#94a3b8", fontWeight: "normal" }}
                            >
                              {ad.edad || ""} años
                            </span>
                          </h3>
                          <div
                            style={{
                              display: "flex",
                              gap: "6px",
                              flexWrap: "wrap",
                              justifyContent: "flex-end",
                            }}
                          >
                            {esPendiente && (
                              <span
                                style={{
                                  fontSize: "0.7rem",
                                  background: "rgba(234,179,8,0.15)",
                                  color: "#eab308",
                                  padding: "3px 8px",
                                  borderRadius: "20px",
                                  fontWeight: "bold",
                                }}
                              >
                                PENDIENTE
                              </span>
                            )}
                            <span
                              style={{
                                fontSize: "0.7rem",
                                background: esPlan30Dias
                                  ? "rgba(16,185,129,0.15)"
                                  : "rgba(100,116,139,0.2)",
                                color: esPlan30Dias ? "#34d399" : "#94a3b8",
                                padding: "3px 8px",
                                borderRadius: "20px",
                                fontWeight: "bold",
                              }}
                            >
                              {esPlan30Dias
                                ? "Plan 30 Días"
                                : "Plan Básico 7 Días"}
                            </span>
                          </div>
                        </div>
                        <p
                          style={{
                            margin: "0 0 6px 0",
                            fontSize: "0.8rem",
                            color: "#94a3b8",
                          }}
                        >
                          <IconoUbicacion />
                          {ad.ubicacion || "Sin ubicación"} | <IconoTelefono />
                          {ad.telefono || "Sin teléfono"}
                        </p>
                        <p
                          style={{
                            margin: 0,
                            fontSize: "0.8rem",
                            color: "#cbd5e1",
                            display: "-webkit-box",
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: "vertical",
                            overflow: "hidden",
                          }}
                        >
                          {ad.descripcion || "Sin descripción"}
                        </p>
                      </div>

                      <div
                        style={{
                          marginTop: "8px",
                          background: esPendiente
                            ? "rgba(234,179,8,0.1)"
                            : tienePlanActivo
                            ? "rgba(34,197,94,0.1)"
                            : "rgba(239,68,68,0.1)",
                          border: esPendiente
                            ? "1px solid rgba(234,179,8,0.3)"
                            : tienePlanActivo
                            ? "1px solid rgba(34,197,94,0.2)"
                            : "1px solid rgba(239,68,68,0.2)",
                          padding: "8px 12px",
                          borderRadius: "10px",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <span
                          style={{
                            fontSize: "0.8rem",
                            color: esPendiente
                              ? "#fde047"
                              : tienePlanActivo
                              ? "#4ade80"
                              : "#fca5a5",
                            fontWeight: "600",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <IconoReloj />{" "}
                          {esPendiente ? "Estado:" : "Tiempo restante:"}
                        </span>
                        <strong
                          style={{
                            fontSize: "0.85rem",
                            color: "#fff",
                            marginLeft: "auto",
                          }}
                        >
                          {esPendiente
                            ? "En revisión"
                            : tienePlanActivo
                            ? `${diasFaltantes} días activos`
                            : "Expirado"}
                        </strong>
                      </div>
                    </div>
                  </div>

                  <div
                    style={{
                      borderTop: "1px solid #334155",
                      paddingTop: "12px",
                      display: "flex",
                      flexDirection: "column",
                      gap: "8px",
                    }}
                  >
                    <span
                      style={{
                        fontSize: "0.75rem",
                        color: "#94a3b8",
                        fontWeight: "bold",
                      }}
                    >
                      Potenciadores del anuncio:
                    </span>

                    {tieneTopActivo && (
                      <div
                        style={{
                          background: "rgba(37,99,235,0.12)",
                          border: "1px solid rgba(37,99,235,0.35)",
                          borderRadius: "8px",
                          padding: "6px 9px",
                          color: "#93c5fd",
                          fontSize: "0.7rem",
                        }}
                      >
                        <IconoEstrella /> Top activo ·{" "}
                        {calcularDiasDesdeFecha(
                          ad.fecha_vencimiento_top,
                          ahora
                        )}{" "}
                        días restantes
                      </div>
                    )}

                    {tieneDestacadoActivo && (
                      <div
                        style={{
                          background: "rgba(217,119,6,0.12)",
                          border: "1px solid rgba(217,119,6,0.35)",
                          borderRadius: "8px",
                          padding: "6px 9px",
                          color: "#fbbf24",
                          fontSize: "0.7rem",
                        }}
                      >
                        <IconoFuego /> Destacado activo ·{" "}
                        {calcularDiasDesdeFecha(
                          ad.fecha_vencimiento_destacado,
                          ahora
                        )}{" "}
                        días restantes
                      </div>
                    )}

                    {tieneSuperTopActivo && (
                      <div
                        style={{
                          background: "rgba(220,38,38,0.12)",
                          border: "1px solid rgba(220,38,38,0.35)",
                          borderRadius: "8px",
                          padding: "6px 9px",
                          color: "#fca5a5",
                          fontSize: "0.7rem",
                        }}
                      >
                        <IconoCohete /> Super Top activo ·{" "}
                        {calcularHorasRestantes(
                          ad.fecha_vencimiento_super_top,
                          ahora
                        )}{" "}
                        horas restantes
                      </div>
                    )}

                    {esVip && (
                      <div
                        style={{
                          background: "rgba(168,85,247,0.12)",
                          border: "1px solid rgba(168,85,247,0.35)",
                          borderRadius: "8px",
                          padding: "6px 9px",
                          color: "#d8b4fe",
                          fontSize: "0.7rem",
                        }}
                      >
                        <IconoCorona /> VIP activo ·{" "}
                        {calcularDiasDesdeFecha(
                          ad.fecha_vencimiento_vip,
                          ahora
                        )}{" "}
                        días restantes
                      </div>
                    )}

                    {esPendiente && tipoCompra === "top_7dias" && (
                      <div
                        style={{
                          background: "rgba(37,99,235,0.10)",
                          border: "1px solid rgba(37,99,235,0.3)",
                          color: "#93c5fd",
                          padding: "7px 10px",
                          borderRadius: "8px",
                          fontSize: "0.7rem",
                          textAlign: "center",
                        }}
                      >
                        ⏳ Solicitud de Top 7 días pendiente de pago.
                      </div>
                    )}
                    {esPendiente && tipoCompra === "destacado_7dias" && (
                      <div
                        style={{
                          background: "rgba(217,119,6,0.10)",
                          border: "1px solid rgba(217,119,6,0.3)",
                          color: "#fbbf24",
                          padding: "7px 10px",
                          borderRadius: "8px",
                          fontSize: "0.7rem",
                          textAlign: "center",
                        }}
                      >
                        ⏳ Solicitud de Destacado 7 días pendiente de pago.
                      </div>
                    )}
                    {esPendiente && tipoCompra === "super_top_24h" && (
                      <div
                        style={{
                          background: "rgba(220,38,38,0.10)",
                          border: "1px solid rgba(220,38,38,0.3)",
                          color: "#f87171",
                          padding: "7px 10px",
                          borderRadius: "8px",
                          fontSize: "0.7rem",
                          textAlign: "center",
                        }}
                      >
                        ⏳ Solicitud de Super Top 24H pendiente de pago.
                      </div>
                    )}

                    {/* Mensaje Informativo si ya tiene un potenciador activo */}
                    {tienePlanActivo && tieneCualquierPotenciadorActivo && (
                      <div
                        style={{
                          background: "rgba(234,179,8,0.1)",
                          border: "1px solid rgba(234,179,8,0.3)",
                          color: "#fde047",
                          padding: "8px 12px",
                          borderRadius: "8px",
                          fontSize: "0.75rem",
                          textAlign: "center",
                          fontWeight: "500",
                        }}
                      >
                        ⏳ {mensajeEsperaPotenciador}
                      </div>
                    )}

                    {/* Fila de botones de potenciadores */}
                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns: esVip30Dias ? "1fr" : "repeat(3, 1fr)",
                        gap: "8px",
                      }}
                    >
                      <button
                        disabled={deshabilitarTop}
                        onClick={() => cambiarPlan(ad.id, "top_7dias", 35)}
                        style={{
                          background: tieneTopActivo
                            ? "#1e40af"
                            : deshabilitarTop
                            ? "#334155"
                            : "#2563eb",
                          color:
                            deshabilitarTop && !tieneTopActivo
                              ? "#94a3b8"
                              : "#fff",
                          border: "none",
                          padding: "9px 8px",
                          borderRadius: "8px",
                          fontSize: "0.73rem",
                          fontWeight: "600",
                          cursor: deshabilitarTop ? "not-allowed" : "pointer",
                          opacity: deshabilitarTop && !tieneTopActivo ? 0.5 : 1,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <IconoEstrella />{" "}
                        {tieneTopActivo
                          ? "Top Activo"
                          : esPendiente
                          ? "Pendiente"
                          : !tienePlanActivo
                          ? "Plan expirado"
                          : tieneCualquierPotenciadorActivo
                          ? "En uso"
                          : "Top 7d (35 Bs)"}
                      </button>

                      {!esVip30Dias && (
                        <button
                          disabled={deshabilitarDestacado}
                          onClick={() =>
                            cambiarPlan(ad.id, "destacado_7dias", 19)
                          }
                          style={{
                            background: tieneDestacadoActivo
                              ? "#9a3412"
                              : deshabilitarDestacado
                              ? "#334155"
                              : "#d97706",
                            color:
                              deshabilitarDestacado && !tieneDestacadoActivo
                                ? "#94a3b8"
                                : "#fff",
                            border: "none",
                            padding: "9px 8px",
                            borderRadius: "8px",
                            fontSize: "0.73rem",
                            fontWeight: "600",
                            cursor: deshabilitarDestacado
                              ? "not-allowed"
                              : "pointer",
                            opacity:
                              deshabilitarDestacado && !tieneDestacadoActivo
                                ? 0.5
                                : 1,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <IconoFuego />{" "}
                          {tieneDestacadoActivo
                            ? "Destacado Activo"
                            : esPendiente
                            ? "Pendiente"
                            : !esPlan30Dias
                            ? "Solo Plan 30d"
                            : !tienePlanActivo
                            ? "Plan expirado"
                            : tieneCualquierPotenciadorActivo
                            ? "En uso"
                            : "Destacado (19 Bs)"}
                        </button>
                      )}

                      {!esVip30Dias && (
                        <button
                          disabled={deshabilitarSuperTop}
                          onClick={() => cambiarPlan(ad.id, "super_top_24h", 59)}
                          style={{
                            background: tieneSuperTopActivo
                              ? "#991b1b"
                              : deshabilitarSuperTop
                              ? "#334155"
                              : "#dc2626",
                            color:
                              deshabilitarSuperTop && !tieneSuperTopActivo
                                ? "#94a3b8"
                                : "#fff",
                            border: "none",
                            padding: "9px 8px",
                            borderRadius: "8px",
                            fontSize: "0.73rem",
                            fontWeight: "600",
                            cursor: deshabilitarSuperTop
                              ? "not-allowed"
                              : "pointer",
                            opacity:
                              deshabilitarSuperTop && !tieneSuperTopActivo
                                ? 0.5
                                : 1,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <IconoCohete />{" "}
                          {tieneSuperTopActivo
                            ? "SuperTop Activo"
                            : esPendiente
                            ? "Pendiente"
                            : !esPlan30Dias
                            ? "Solo Plan 30d"
                            : !tienePlanActivo
                            ? "Plan expirado"
                            : tieneCualquierPotenciadorActivo
                            ? "En uso"
                            : "SuperTop (59 Bs)"}
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}

        {/* BOTÓN VOLVER ESTILO BURBUJA FLOTANTE EN LA PARTE INFERIOR */}
        <div
          style={{
            position: "fixed",
            bottom: "20px",
            left: 0,
            width: "100%",
            display: "flex",
            justifyContent: "center",
            zIndex: 900,
            pointerEvents: "none",
          }}
        >
          <button
            onClick={alVolver}
            style={{
              pointerEvents: "auto",
              background: "#0f172a",
              border: "1px solid #334155",
              color: "#fff",
              padding: "12px 24px",
              borderRadius: "30px",
              cursor: "pointer",
              fontWeight: "700",
              fontSize: "0.95rem",
              display: "inline-flex",
              alignItems: "center",
              boxShadow: "0 8px 25px rgba(0,0,0,0.4)",
              transition: "transform 0.2s ease, background 0.2s ease",
            }}
          >
            <IconoFlechaIzquierda /> Volver
          </button>
        </div>

        {modalConfirmar && datosPendientesPago && (
          <div
            style={{
              position: "fixed",
              inset: 0,
              background: "rgba(0,0,0,0.75)",
              backdropFilter: "blur(5px)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 99999,
            }}
          >
            <div
              style={{
                background: "#0f172a",
                border: "1px solid #334155",
                borderRadius: "20px",
                padding: "30px",
                width: "90%",
                maxWidth: "400px",
                textAlign: "center",
                boxShadow: "0 15px 40px rgba(0,0,0,.4)",
                color: "#fff",
              }}
            >
              <div
                style={{
                  marginBottom: "15px",
                  display: "inline-flex",
                  padding: "12px",
                  background: "rgba(220,38,38,0.1)",
                  borderRadius: "50%",
                  color: "#ef4444",
                }}
              >
                <IconoCohete />
              </div>
              <h3
                style={{
                  margin: 0,
                  fontSize: "1.4rem",
                  fontWeight: "700",
                  color: "#fff",
                }}
              >
                Confirmar Suscripción
              </h3>
              <p
                style={{
                  marginTop: "12px",
                  color: "#94a3b8",
                  fontSize: "0.95rem",
                  lineHeight: "1.5",
                }}
              >
                ¿Deseas solicitar{" "}
                <strong style={{ color: "#fff" }}>
                  {datosPendientesPago.nombrePlan}
                </strong>{" "}
                por{" "}
                <strong style={{ color: "#34d399" }}>
                  {datosPendientesPago.precio} Bs
                </strong>
                ?
              </p>
              <div style={{ display: "flex", gap: "10px", marginTop: "24px" }}>
                <button
                  onClick={() => setModalConfirmar(false)}
                  style={{
                    flex: 1,
                    background: "#334155",
                    color: "#fff",
                    border: "none",
                    padding: "12px",
                    borderRadius: "12px",
                    fontWeight: "bold",
                    cursor: "pointer",
                  }}
                >
                  Cancelar
                </button>
                <button
                  onClick={ejecutarCambioPlan}
                  style={{
                    flex: 1,
                    background: "#ff3366",
                    color: "#fff",
                    border: "none",
                    padding: "12px",
                    borderRadius: "12px",
                    fontWeight: "bold",
                    cursor: "pointer",
                  }}
                >
                  Aceptar y Pagar
                </button>
              </div>
            </div>
          </div>
        )}

        {modalExito && (
          <div
            style={{
              position: "fixed",
              inset: 0,
              background: "rgba(0,0,0,0.75)",
              backdropFilter: "blur(5px)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 99999,
            }}
          >
            <div
              style={{
                background: "#fff",
                borderRadius: "20px",
                padding: "30px",
                width: "90%",
                maxWidth: "450px",
                textAlign: "center",
                boxShadow: "0 15px 40px rgba(0,0,0,.25)",
              }}
            >
              <div style={{ fontSize: "60px", marginBottom: "15px" }}>🚀</div>
              <h2
                style={{
                  margin: 0,
                  color: "#0f172a",
                  fontSize: "28px",
                  fontWeight: "700",
                }}
              >
                Potenciador Activado
              </h2>
              <p
                style={{
                  marginTop: "15px",
                  color: "#64748b",
                  lineHeight: "1.6",
                }}
              >
                Tu pago fue confirmado automáticamente y el potenciador ya se
                encuentra activo.
              </p>
              <button
                onClick={() => setModalExito(false)}
                style={{
                  marginTop: "20px",
                  background: "#ff3366",
                  color: "#fff",
                  border: "none",
                  padding: "12px 30px",
                  borderRadius: "12px",
                  cursor: "pointer",
                  fontWeight: "bold",
                  fontSize: "16px",
                }}
              >
                Continuar
              </button>
            </div>
          </div>
        )}

{modalQR && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              background: "rgba(0,0,0,0.7)",
              backdropFilter: "blur(5px)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 1000,
              padding: "20px",
            }}
          >
            <div
              style={{
                background: "#fff",
                padding: "24px",
                borderRadius: "16px",
                maxWidth: "420px",
                width: "100%",
                textAlign: "center",
                color: "#0f172a",
                boxShadow: "0 10px 25px rgba(0,0,0,0.3)",
              }}
            >
              <h3
                style={{
                  fontSize: "1.3rem",
                  fontWeight: "800",
                  marginBottom: "8px",
                  color: "#0f172a",
                }}
              >
                Realiza el Pago por QR
              </h3>
              <p
                style={{
                  fontSize: "0.85rem",
                  color: "#64748b",
                  marginBottom: "16px",
                }}
              >
                Escanea el código QR o toma captura. El sistema se activará automáticamente al recibir el pago.
              </p>

              {/* CONTENEDOR AMPLIADO PARA HACER EL QR MÁS GRANDE */}
              <div
                style={{
                  background: "#f8fafc",
                  padding: "16px",
                  borderRadius: "12px",
                  border: "1px solid #e2e8f0",
                  marginBottom: "16px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  minHeight: "280px",
                }}
              >
                {cargandoQr ? (
                  <p style={{ fontSize: "0.9rem", color: "#64748b" }}>
                    Generando QR automático...
                  </p>
                ) : qrImagenBase64 ? (
                  <img
                    src={`data:image/png;base64,${qrImagenBase64}`}
                    alt="QR de Pago"
                    style={{
                      width: "260px",
                      height: "260px",
                      objectFit: "contain",
                      display: "block",
                      margin: "0 auto",
                    }}
                  />
                ) : (
                  <p style={{ fontSize: "0.9rem", color: "#ef4444" }}>
                    No se pudo cargar la imagen del QR.
                  </p>
                )}
              </div>

              {/* MENSAJE INDICATIVO EN VEZ DEL BOTÓN CERRAR */}
              <div
                style={{
                  background: "rgba(234, 179, 8, 0.12)",
                  border: "1px solid rgba(234, 179, 8, 0.4)",
                  color: "#b45309",
                  padding: "12px 14px",
                  borderRadius: "10px",
                  fontSize: "0.85rem",
                  fontWeight: "600",
                  lineHeight: "1.4",
                }}
              >
                📸 Toma captura QR y luego dirígete a tu billetera móvil para que subas la captura y puedas pagar.
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default MisAnuncios;